import Vue from 'vue'
import {$equipments} from '@/services/'

const module = {
  namespaced: true,

  state: {
    items: null,
    meta: { pagination: {} },
    item: {},
  },

  getters: {
    items: state => state.items,
    meta: state => state.meta,
    item: state => state.item,
  },

  mutations: {
    ITEMS(state,value){
      state.items = value
    },

    META(state, meta){
      state.meta = meta
    },

    ITEM(state,value){
      state.item = value
    },

    UPDATE(state, {id, data}){
      var index = state.items.findIndex(obj => obj.id == id)
      index > -1 && Vue.set(state.items, index, data)
      if(state.item.id == id){
        state.item = {...state.item, ...data}
      }
    },
  },

  actions: {
    
    all({ commit }, { config }){
      return $equipments.all(config)
        .then(function(res){
          let {data, meta} = res.data
          commit('ITEMS', data)
          commit('META', meta)
          return res
        })
    },

    find({ commit }, { id, config }){
      return $equipments.show(id, config)
      .then(res => {
        commit('ITEM', res.data.data)
        return res
      })
    },

    update({commit}, {id, payload, config}){
      console.log('project update')
      return $equipments.update(id, payload, config).then(res => {
        let { data }= res.data
        commit('UPDATE', {id, data})
        return res
      })
    },
  }
}

export default module
